import {
  BlankSlate,
  Description,
  PrimaryActionButton
} from '@cjdev/visual-stack/lib/components/BlankSlate'

import './UnblockSuccessMessage.css'
import cjHeaderLogo from './cj_logo_green.svg'

export const UnblockSuccessMessage = (props) => {
  const brand = sessionStorage.getItem('brand')
  sessionStorage.removeItem('brand')

  if (brand === 'booking') {
    const destination = new URL('/unblocked-account-success', 'https://public.cj.com')
    destination.searchParams.set('brand', 'booking')
    window.location.href = destination.href
    return null
  }

  return (
  <BlankSlate
    title={'Account Unblocked'}
    headerGraphic={
      <img height={'50px'} src={cjHeaderLogo} alt={'CJ Affiliate'} className={'headerGraphic'} />
    }
  >
    <Description>Your account has been unblocked successfully.</Description>

    <PrimaryActionButton
      label={'Return to login'}
      handler={() => props.history.push('https://members.cj.com/member/login')}
    />
  </BlankSlate>
  )
}
